import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CodaltComponent } from '../../codalt.component';
import { CustomerProject } from '../../customer-project.interface';
import { AuthorisationService } from '../../services/auth/authorisation.service';
import { CustomerProjectService } from '../../services/customer-project/customer-project.service';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { SearchService } from '../../services/search/search.service';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    standalone: false,
})
export class TimelineComponent extends CodaltComponent implements OnInit, OnDestroy {
    projects: CustomerProject[];

    constructor(
        private customerProjectService: CustomerProjectService,
        private searchService: SearchService,
        private router: Router,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Tijdlijn');
        if (AuthorisationService.hasFeature(this.Features.CustomerProjects)) {
            this.customerProjectService.getProjects(true).subscribe(projects => {
                this.projects = projects;
                if (
                    this.projects.length === 1 &&
                    AuthorisationService.hasFunctionality(this.Functionalities.CustomerProjectsSubscribe)
                ) {
                    const project = this.projects[0];
                    this.router.navigate(
                        [
                            this.Routenames.customers,
                            project.customer_id,
                            this.Routenames.projects,
                            project.id,
                            this.Routenames.timeline,
                        ],
                        { replaceUrl: true }
                    );
                }
                this.searchService.searchTemplate = null;
            });
        } else if (AuthorisationService.hasFeature(this.Features.CustomersRecentSorted)) {
            this.router.navigate([this.Routenames.customers], { replaceUrl: true });
        } else {
            this.router.navigate([this.Routenames.settings], { replaceUrl: true });
        }
    }
}
